import { ProblemStatisticsPresenter } from '@/presentation/presenters/problem/problemStatisticsPresenter'
import { ProblemStatisticsViewModel } from '@/presentation/viewmodels/problem/problemStatisticsViewModel'

export function useProblemStatisticsPresenter(
  presenter: ProblemStatisticsPresenter = new ProblemStatisticsPresenter(new ProblemStatisticsViewModel())
) {
  return {
    problemAttachment: presenter.problemAttachment,
    problemStatistics: presenter.problemStatistics,
    officialProblemCategoryList: presenter.officialProblemCategoryList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    getProblemStatistics: presenter.getProblemStatistics.bind(presenter),
    getOfficialProblemCategory: presenter.getOfficialProblemCategory.bind(presenter)
  }
}
